import React, { memo, TextareaHTMLAttributes, useEffect, useRef } from 'react';
import classNames from 'classnames';
import cls from './ModalInput.module.css';
import { useSelector } from 'react-redux';

interface IModalInputProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    isError: boolean;
    autoFocus?: boolean;
    onChangeHandler: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    classes?: string;
    triggerAnimationError?: boolean;
    setTriggerAnimationError?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ModalInput: React.FC<IModalInputProps> = memo(
    ({
        autoFocus,
        onChangeHandler,
        classes,
        isError,
        setTriggerAnimationError,
        triggerAnimationError,
        ...rest
    }) => {
        const inputRef = useRef<HTMLTextAreaElement>(null);
        //@ts-ignore
        const { modalMode } = useSelector((store) => store.taskBoardReducer);

        useEffect(() => {
            if (autoFocus || modalMode === 'addNewTask') {
                inputRef.current?.focus();
            }
            adjustHeight();
        }, [autoFocus, modalMode]);

        useEffect(() => {
            if (triggerAnimationError || isError) {
                const timeout = setTimeout(() => setTriggerAnimationError(false), 500);
                return () => clearTimeout(timeout);
            }
        }, [triggerAnimationError]);

        const adjustHeight = () => {
            if (inputRef.current) {
                inputRef.current.style.height = '20px';
                inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
            }
        };

        return (
            <textarea
                ref={inputRef}
                {...rest}
                className={classNames(
                    cls.Input,
                    classes,
                    isError && cls.Error,
                    triggerAnimationError && cls.WiggleError
                )}
                autoFocus={modalMode === 'addNewTask'}
                onChange={(e) => {
                    onChangeHandler(e);
                    adjustHeight();
                }}
                onInput={adjustHeight}
                maxLength={512}
                style={{ overflow: 'hidden', resize: 'none' }}
            />
        );
    }
);

// import React, { memo, TextareaHTMLAttributes, useEffect, useRef } from 'react';
// import classNames from 'classnames';
// import cls from './ModalInput.module.css';
// import { useSelector } from 'react-redux';
//
// interface IModalInputProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
//     isError: boolean;
//     autoFocus?: boolean;
//     onChangeHandler: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
//     classes?: string;
//     triggerAnimationError?: boolean;
//     setTriggerAnimationError?: React.Dispatch<React.SetStateAction<boolean>>;
// }
//
// export const ModalInput: React.FC<IModalInputProps> = memo(
//     ({
//         autoFocus,
//         onChangeHandler,
//         classes,
//         isError,
//         setTriggerAnimationError,
//         triggerAnimationError,
//         ...rest
//     }) => {
//         const inputRef = useRef<HTMLTextAreaElement>(null);
//         //@ts-ignore
//         const { modalMode } = useSelector((store) => store.taskBoardReducer);
//
//         useEffect(() => {
//             if (autoFocus || modalMode === 'addNewTask') {
//                 inputRef.current?.focus();
//             }
//         }, [autoFocus, modalMode]);
//
//         useEffect(() => {
//             if (triggerAnimationError || isError) {
//                 const timeout = setTimeout(() => setTriggerAnimationError(false), 500);
//                 return () => clearTimeout(timeout);
//             }
//         }, [triggerAnimationError]);
//
//         return (
//             // <input
//             //     ref={inputRef}
//             //     {...rest}
//             //     className={classNames(
//             //         cls.Input,
//             //         classes,
//             //         isError && cls.Error,
//             //         triggerAnimationError && cls.WiggleError
//             //     )}
//             //     autoFocus={modalMode === 'addNewTask'}
//             //     onChange={onChangeHandler}
//             //     maxLength={512}
//             // />
//             <textarea
//                 ref={inputRef}
//                 {...rest}
//                 className={classNames(
//                     cls.Input,
//                     classes,
//                     isError && cls.Error,
//                     triggerAnimationError && cls.WiggleError
//                 )}
//                 autoFocus={modalMode === 'addNewTask'}
//                 onChange={onChangeHandler}
//                 maxLength={512}
//             />
//         );
//     }
// );
